import type { GiftCard, GiftCardGroup } from '../GiftCards.types'

export const isGiftCardGroup = (giftCard: GiftCard): giftCard is GiftCardGroup =>
  'groupId' in giftCard
